<template>
  <div class="flex flex-col gap-2">
    <p>
      {{ group.notes }}
    </p>
    <div class="stats">
      <span>{{ i18n.t('applicationsCount', appCount) }}</span>
      <div id="dot" />
      <span>{{ i18n.t('licensesCount', licenseCount) }}</span>
      <div id="dot" />
      <span>{{ i18n.t('accountsCount', group.accounts.length) }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { saasmetrix__models__account__AccountGroup__AccountGroup as AccountGroup } from '@/client'
  import { useI18n } from 'vue-i18n'
  const props = defineProps<{ group: AccountGroup }>()

  const i18n = useI18n()

  // Calculate number of applications assigned
  const appCount = computed(() => {
    const permissions = props.group.permission?.software_permissions || {}
    return Object.keys(permissions).length
  })

  // Calculate total number of licenses assigned
  const licenseCount = computed(() => {
    const permissions = props.group.permission?.software_permissions || {}
    return Object.values(permissions).reduce(
      (sum: number, perm: Record<string, unknown>) => {
        // Count licenses from sub_account_permissions
        if (perm.sub_account_permissions) {
          for (const subPerm of Object.values(
            perm.sub_account_permissions as Record<string, unknown>[]
          )) {
            if (subPerm.software_license_permissions) {
              sum += Object.keys(
                subPerm.software_license_permissions as Record<string, unknown>
              ).length
            }
          }
        }
        return sum
      },
      0
    )
  })
</script>

<style scoped lang="scss">
  #dot {
    height: 6px;
    width: 6px;
    border-radius: 3px;
    background-color: var(--sm-contrast-muted);
  }

  .stats {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: var(--sm-contrast-muted);
  }
</style>
